import { ElectricLoad } from '../../../../../../domain/ElectricLoad';
import { Percent } from '../../../../../../domain/Percent';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class LoadingPercentEvaluation {
  private readonly ruleName = 'Mv_AcLineSegment_LoadingPercent';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(loadingPercent: number): EvaluationResultType<ElectricLoad> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(rule?.value, loadingPercent);
    const value = ElectricLoad.fromPercent(Percent.fromFloat(loadingPercent));
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
